/*eslint-disable*/
import axios from "axios";
import apiConfig from "./api.config";
import { baseBackUrl } from "../assets/linkTree";

class UserService {
  getAll() {
    return axios.get(baseBackUrl + "api/usuarios", apiConfig.connData());
  }
  getRoles() {
    return axios.get(baseBackUrl + "api/roles", apiConfig.connData());
  }
  addUser(user) {
    return axios.post(
      baseBackUrl + "api/usuarios",
      user,
      apiConfig.connData()
    );
  }
  editUser(id, obj) {
    return axios.put(
      baseBackUrl + "api/usuarios/" + id,
      obj,
      apiConfig.connData()
    );
  }
  changePass(id, pass) {
    return axios.put(
      baseBackUrl + "api/pass/" + id,
      pass,
      apiConfig.connData()
    );
  }
  deleteUser(id) {
    return axios.delete(
      baseBackUrl + "api/usuarios/" + id,
      apiConfig.connData()
    );
  }
  forgotPassword(email) {
    return axios.post(baseBackUrl + "api/forgotPassword", { email: email });
  }
  async isPINcorrect(email, code) {
    return await axios
      .post(
        baseBackUrl + "api/code",
        {
          email: email,
          code: code
        },
        apiConfig.connData()
      )
      .catch(() => {
        return {};
      });
  }
  async changePassForgot(id, newpass) {
    var val = false;
    await axios
      .post(baseBackUrl + "api/passForgot/" + id, {
        newpassword: newpass
      })
      .then(response => {
        val = true;
      })
      .catch(() => {
        val = false;
      });
    return val;
  }
}
export default new UserService();



// WEBPACK FOOTER //
// ./src/services/UserService.js